export const sha256Hex = async (value) => {
  if (!value || !window?.crypto?.subtle) {
    return null;
  }

  const encodedValue = new TextEncoder().encode(value);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", encodedValue);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
};
